import { DocPage, Section, SpecTable } from "../../components/DocChrome";

export function ContentPage() {
    return (
        <DocPage
            title="Content & UX Writing"
            description="Same action → same terminology across Owner, Tenant, Rider, Customer."
        >
            <Section title="Terminology">
                <SpecTable
                    rows={[
                        ["Save", "Persist settings / profile"],
                        ["Create", "New entity"],
                        ["Update", "Edit existing entity"],
                        ["Delete / Remove", "Destructive — confirm"],
                        ["Sync", "Rider offline queue flush"],
                        ["Collect cash", "Rider delivery payment"],
                        ["Pay now", "Customer online payment"],
                        ["Retry", "Failed async recovery"],
                    ]}
                />
            </Section>
            <Section title="Tone">
                <ul className="list-disc space-y-1 ps-5">
                    <li>
                        Professional, concise, operations-first — no playful marketing copy in
                        panels.
                    </li>
                    <li>Errors name the problem and the next step.</li>
                    <li>Empty states explain why and what to do next.</li>
                </ul>
            </Section>
        </DocPage>
    );
}
